import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompaniesDetailComponent } from './companies-detail/companies-detail.component';
import { CompaniesListComponent } from './companies-list/companies-list.component';

const routes: Routes = [
  { path: "companies", component: CompaniesListComponent },
  { path: "companies/:id", component: CompaniesDetailComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CompaniesRoutingModule { }
